<template>
  <div>
     <label> Mark entry </label>
    <div v-if="ctx.markEntryFor !='TENTH' && ctx.markEntryFor !='UG'" class="form-group formways-component formways-textfield">
      <label :for="streamId"> Stream </label>
      <select class="form-control" v-model="streamId" id="streamId">
        <option value="">select</option>
        <option v-for="stream in streamList" :key="stream.id" :value="stream.id">{{ stream.name }}</option>
      </select>
    </div>
    <tableMarkentry v-if="ctx.markEntryFor !='UG'" :subject-list="subjectList" :mark-list="markList" :markentry-conf="ctx"></tableMarkentry>
    <termWiseMarkentry v-else-if="ctx.markEntryFor=='UG'" :markentry-conf="ctx" @save-mark="setMark"></termWiseMarkentry>
  </div>
</template>
<script>
/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
import Axios from "axios";
import SimpleComponentMixin from "../../mixins/SimpleComponentMixin";
import defaultSchema from "./markentryDefaultSchema";
import tableMarkentry from "./tableMarkentry.vue";
import termWiseMarkentry from "./termWiseMarkentry.vue";

// TODO: Add a better key for v-for
export default {
  name: "markentry",
  components:{
    tableMarkentry,
    termWiseMarkentry
  },
  mixins: [SimpleComponentMixin],
  beforeCreate() {
    const self = this;
    self.defaultSchema = defaultSchema;
    Axios.get("/admapi/qualification/stream/HSS").then(function (response) {
      self.streamList = response.data;
    });
  },
  mounted(){
    const self = this;
    self.setMarkList();
  },
  data() {
    return {
      markList: [],
      subjectList: [],
      streamList: [],
      streamId: ""
    };
  },
  methods: {
    setMarkList(){
      const self = this;
      if(self.ctx.subjectConf.displaySubjectBy==="DROPDOWN"){
        for(let i=0;i<self.ctx.subjectConf.numberOfSubject;i++){
          const studentMark={};
          studentMark.subjectId="";
          studentMark.subjectName="";
          studentMark.markObtained="";
          studentMark.maxMark="";
          if(self.ctx.subjectConf.enableIsCore){
            studentMark.isCore=false;
          }
          self.markList.push(studentMark);
        }
        
      }
      else{
        self.subjectList.forEach(subject => {
          const studentMark={};
          studentMark.subjectId=subject.subjectId;
          studentMark.markObtained="";
          studentMark.subjectName=subject.subjectName;
          studentMark.maxMark=subject.maxMark;
          self.markList.push(studentMark);
        });
      }
    },
    setMark(response){
      this.markList=response;
    }
  },
  watch: {
    streamId() {
      const self = this;
      if (this.streamId) {
        Axios.get("/admapi/qualification/streamSubject/".concat(self.streamId)).then(function (response) {
          self.subjectList = response.data;
        });
      }
    },
    markList(){
      this.value=this.markList;
    }
  }
};
</script>
